/// *** System import ***///
import { Component } from '@angular/core';
import { ViewController, ToastController } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../../../app/globals';
import { SessionProvider } from '../../../../../providers/session';
import { Market_SessionStore } from '../../session.store';

@Component({
  selector: 'page-market-session-params',
  templateUrl: 'params.html',
})
export class Market_SessionParamsPopover {
  private instrumentGroups: any = [
    { code: '11', name: 'Continu', isSelected: false },
    { code: '12', name: 'Fixing', isSelected: false },
    { code: '13', name: 'Hors côte', isSelected: false },
    { code: '21', name: 'Titres de créance', isSelected: false },
    { code: '32', name: 'Lignes secondaires', isSelected: false },
    { code: '33', name: 'Lignes secondaires', isSelected: false },
    { code: '51', name: 'Marché alternatif', isSelected: false },
    { code: '52', name: 'Alternatif Fixing', isSelected: false },
    { code: '71', name: 'Autres emprunts', isSelected: false },
    { code: '99', name: 'Fixing', isSelected: false }];
  constructor(
    // *** System
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    // *** Custom 
    private globals: Globals,
    private session: SessionProvider,
    private store: Market_SessionStore) {
    if (this.store.params.groups && (this.store.params.groups != '')) {
      for (let _instrumentGroup of this.instrumentGroups) {
        _instrumentGroup.isSelected = false;
      }
      for (let _group of this.store.params.groups.split(',')) {
        let group = this.instrumentGroups.find(item => item.code == _group);
        if (group)
          group.isSelected = true;
      }
    }
  }

  // *** Fermer la fenêtre et appliquer les paramètres
  private _dismiss() {
    try {
      this.store.params.groups = this.instrumentGroups.filter(item => item.isSelected).map(item => item.code).join(',');
      this.viewCtrl.dismiss();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.viewCtrl.dismiss();
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/market/session/popovers/params/params.ts